module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "root",
    staticClass: "chat-input"
  }, [(_vm.attachments.length) ? _c('div', {
    staticClass: "attach-preview"
  }, _vm._l((_vm.attachments), function(a) {
    return _c('div', {
      key: a.localId,
      staticClass: "attach-card",
      class: {
        uploading: a.status === 'uploading',
        error: a.status === 'error'
      }
    }, [(a.isImage && a.previewUrl) ? _c('div', {
      staticClass: "thumb"
    }, [_c('img', {
      attrs: {
        "src": a.previewUrl,
        "alt": "preview"
      }
    })]) : _c('div', {
      staticClass: "thumb file"
    }, [_vm._v("📄")]), _vm._v(" "), _c('div', {
      staticClass: "meta"
    }, [_c('div', {
      staticClass: "name",
      attrs: {
        "title": a.name
      }
    }, [_vm._v(_vm._s(a.name))]), _vm._v(" "), _c('div', {
      staticClass: "sub"
    }, [(a.status === 'uploading') ? _c('span', [_vm._v("Enviando...")]) : (a.status === 'error') ? _c('span', [_vm._v("Falhou")]) : _c('span', [_vm._v(_vm._s(_vm.prettySize(a.size)))])])]), _vm._v(" "), _c('button', {
      staticClass: "remove",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.removeAttachment(a.localId)
        }
      }
    }, [_vm._v("×")])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "icon-btn",
    attrs: {
      "type": "button",
      "title": "Anexar"
    },
    on: {
      "click": _vm.openFileDialog
    }
  }, [_vm._v("📎")]), _vm._v(" "), _c('input', {
    ref: "file",
    staticClass: "file-input",
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": _vm.accept
    },
    on: {
      "change": _vm.onFilePicked
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "emoji-wrap"
  }, [_c('button', {
    staticClass: "icon-btn",
    attrs: {
      "type": "button",
      "title": "Emojis"
    },
    on: {
      "click": _vm.toggleEmoji
    }
  }, [_vm._v("😊")]), _vm._v(" "), (_vm.emojiOpen) ? _c('div', {
    staticClass: "emoji-popover"
  }, [_c('emoji-picker', {
    attrs: {
      "recent": _vm.recentEmojis
    },
    on: {
      "select": _vm.onEmojiSelect,
      "close": _vm.closeEmoji
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    ref: "input",
    attrs: {
      "placeholder": "Digite uma mensagem..."
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.send.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "send-btn",
    attrs: {
      "type": "button",
      "disabled": _vm.sendDisabled
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v("\n      " + _vm._s(_vm.hasUploading ? 'Enviando...' : 'Enviar') + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-331f9ece","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/chat-plugin/components/ChatInput.vue
// module id = 1776
// module chunks = 18